import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useWebinarRedirect } from '@/hooks/useWebinarRedirect';

export default function WebinarRedirectPage() {
  const { data, isLoading } = useWebinarRedirect();

  const url = data?.url?.trim() ?? '';
  const isValid = /^https?:\/\//i.test(url);
  const active = !!data?.enabled && isValid;

  useEffect(() => {
    if (active) window.location.replace(url);
  }, [active, url]);

  if (isLoading || active) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-muted-foreground">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
        <p>Redirigiendo…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-2xl font-bold text-foreground">Webinar no disponible</h1>
      <p className="text-muted-foreground max-w-md">
        En este momento no hay un webinar activo. Vuelve pronto o explora la plataforma.
      </p>
      <Button asChild>
        <Link to="/">Ir al inicio</Link>
      </Button>
    </div>
  );
}
